'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propsUtil = require('../_util/props-util');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _tooltip = require('../tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _inputProps = require('./inputProps');

var _inputProps2 = _interopRequireDefault(_inputProps);

var _vueTypes = require('../_util/vue-types');

var _vueTypes2 = _interopRequireDefault(_vueTypes);

var _BaseMixin = require('../_util/BaseMixin');

var _BaseMixin2 = _interopRequireDefault(_BaseMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    name: 'GInputInline',
    mixins: [_BaseMixin2['default']],
    inheritAttrs: false,
    model: {
        prop: 'value',
        event: 'change.value'
    },
    props: (0, _extends3['default'])({}, _inputProps2['default'], {
        label: _vueTypes2['default'].string.def(''),
        prefixCls: _vueTypes2['default'].string.def('gda-input-inline'),
        inputPrefixCls: _vueTypes2['default'].string.def('gda-input'),
        action: _vueTypes2['default'].string.def('click'),
        visibilityToggle: _vueTypes2['default'].bool.def(true)
    }),
    data: function data() {
        return {
            editing: false,
            showToolTip: false
        };
    },

    methods: {
        focus: function focus() {
            this.$refs.input.focus();
        },
        blur: function blur() {
            this.$refs.input.blur();
        },
        getIcon: function getIcon() {
            var h = this.$createElement;
            var prefixCls = this.$props.prefixCls;

            var iconProps = {
                props: {
                    type: 'edit-fill'
                },
                on: {
                    mousedown: function mousedown(e) {
                        // Prevent focused state lost
                        // https://github.com/ant-design/ant-design/issues/15173
                        e.preventDefault();
                    },
                    mouseup: function mouseup(e) {
                        // Prevent focused state lost
                        // https://github.com/ant-design/ant-design/pull/23633/files
                        e.preventDefault();
                    }
                },
                'class': prefixCls + '-icon',
                key: 'editIcon'
            };
            return h(_icon2['default'], iconProps);
        }
    },
    render: function render() {
        var _classNames,
            _this = this;

        var h = arguments[0];

        var _getOptionProps = (0, _propsUtil.getOptionProps)(this),
            prefixCls = _getOptionProps.prefixCls,
            inputPrefixCls = _getOptionProps.inputPrefixCls,
            size = _getOptionProps.size,
            suffix = _getOptionProps.suffix,
            visibilityToggle = _getOptionProps.visibilityToggle,
            restProps = (0, _objectWithoutProperties3['default'])(_getOptionProps, ['prefixCls', 'inputPrefixCls', 'size', 'suffix', 'visibilityToggle']);

        var suffixIcon = this.getIcon();
        var inputClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, !!size), (0, _defineProperty3['default'])(_classNames, prefixCls + '-editing', !!this.editing), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', !!this.disabled), _classNames));
        var inputProps = {
            attrs: (0, _extends3['default'])({
                type: 'text',
                contenteditable: this.disabled ? false : 'plaintext-only'
            }, this.$attrs),
            ref: 'input',
            'class': prefixCls + '-inner',
            on: (0, _extends3['default'])({
                focus: function focus() {
                    _this.setState({ editing: true });
                },
                blur: function blur(e) {
                    var value = e.target.textContent || ' ';

                    _this.setState({ editing: false });
                    _this.$emit('change.value', value);
                    _this.$emit('change', value);
                    _this.$emit('input', value);
                },
                click: function click() {
                    if (_this.disabled) return;

                    _this.setState({ editing: true, showToolTip: false }, function () {
                        _this.focus();
                    });
                },
                mouseenter: function mouseenter() {
                    var value = restProps.value ? restProps.value.trim() : '';

                    !_this.editing && value && _this.setState({ showToolTip: true });
                },
                mouseleave: function mouseleave() {
                    _this.setState({ showToolTip: false });
                },
                keydown: function keydown(e) {
                    // 禁用回车换行，只允许单行文本输入
                    e.keyCode == 13 && e.preventDefault();
                }
            }, (0, _propsUtil.getListeners)(this))
        };

        return h(
            'span',
            { 'class': inputClassName },
            [h(
                _tooltip2['default'],
                {
                    'class': prefixCls + '-tooltip',
                    attrs: { title: this.label || restProps.value,
                        visible: this.showToolTip,
                        align: { offset: [0, 5] }
                    }
                },
                [h(
                    'span',
                    inputProps,
                    [restProps.value]
                ), suffixIcon]
            )]
        );
    }
};